import type { IconSvgObject } from './types';

const OctagonIcon: IconSvgObject = [
  ["path", { d: "M15.5858 22H8.41421C8.149 22 7.89464 21.8946 7.70711 21.7071L2.29289 16.2929C2.10536 16.1054 2 15.851 2 15.5858V8.41421C2 8.149 2.10536 7.89464 2.29289 7.70711L7.70711 2.29289C7.89464 2.10536 8.149 2 8.41421 2H15.5858C15.851 2 16.1054 2.10536 16.2929 2.29289L21.7071 7.70711C21.8946 7.89464 22 8.149 22 8.41421V15.5858C22 15.851 21.8946 16.1054 21.7071 16.2929L16.2929 21.7071C16.1054 21.8946 15.851 22 15.5858 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default OctagonIcon;
